<template>
  <div class="packages-container">
    <div id="carousel-container">
      <carousel @packageCompareToggled="compareToggled" :packageCompareToggled="packageCompareToggled" :imagesList="imagesList" :discount="getDiscount(pkg)" :pkg="pkg" @openGallery="openGallery"></carousel>
    </div>

    <div class="package-details">
      <div class="package-naming-container">

        <p class="package-name">
          <a :href="detailsURL" v-text="pkg.packageTitle"></a>
        </p>
        <div class="package-seller-duration">
          <div class="package-duration">
            <p class="nights">
              <span v-text="pkg.packageDuration"></span>
              Nights /
            </p>
            <p class="days">
              <span v-text="pkg.packageDuration + 1"></span>
              Days
            </p>
          </div>
          <div class="seller-info-box">
            <p class="seller-info">
              <span class="seller-title">Seller : </span>
              <span class="seller-name" v-if="pkg.isYatraPackage" v-text="pkg.vendorName"></span>
              <a class="seller-name" v-else v-text="pkg.vendorName" target="_new" :href="'/holidays/vendor/landing.htm?vendorId=' + pkg.vendorDetails.id">
              </a>
            </p>
          </div>
        </div>
        <div class="package-destination-itenary">
          <div v-text="packageDurationString" class="package-destinations"></div>
          <div class="tooltip-container package-remain-count" v-if="pkg.cityDurations.length-maxDestinationDispCount>0">
            <a class="show-tooltip">
              + {{pkg.cityDurations.length-maxDestinationDispCount}}
            </a>
            <div class="tooltip-box tooltip-highlight up-arrow">
              <p class="heading">Destinations</p>
              <ul class="list">
                <a class="show-tooltip">
                  <li  v-for="destination in pkg.cityDurations" :key="destination.destinationId">
                    {{destination.destinationName + ' (' + destination.maxNights + 'N)'}}
                  </li>
                </a>
              </ul>
            </div>
          </div>
        </div>
        <div class="package-inclusions">
          <ul>
            <!-- <p class="inclusion">Inclusions:</p> -->
            <li v-for="inclusion in pkg.packageInclusionTypes.slice(0, 4)" :key="inclusion">
              <template v-if="inclusion === 'Flights'">
                <p class="icon-top flight-ico">
                  <i class="icon icon-flight"></i>
                </p>
                <p class="icon-name" v-text="pkg.travelBy && pkg.travelBy.toLowerCase() == 'airland' ? 'Flights' : 'Optional'"></p>
              </template>
              <template v-else>
                <p class="icon-top">
                  <i class="icon" :class="'icon-' + inclusionClass[inclusion]"></i>
                </p>
                <p class="icon-name" v-text="inclusion == 'Accommodation' ? 'Hotel' : inclusion"></p>
              </template>
            </li>
          </ul>
        </div>
        <div class="package-footer">
          <div class="deal" v-if="pkg.offers && pkg.offers.length>0">
            <div class="tooltip-container package-offers-container">
	            <a class="show-tooltip">
	               View Offers <sup class="offers-count">{{pkg.offers.length}}</sup>
	            </a>
	            <div class="tooltip-box tooltip-highlight up-arrow">
	              <p class="heading">Offers</p>
	              <ul class="list">
	                <a class="show-tooltip">
	                  <li  v-for="offer in pkg.offers" :key="destination">
	                    {{offer}}
	                  </li>
	                </a>
	              </ul>
	            </div>
	          </div>
          </div>
        </div>

      </div>
      <div class="package-price-container">
        <div class="price-container">
          <div class="emi-box" v-if="pkg.emiDetails.amount">

            <p class="emi-rupees">
              <span class="emi-tag">Emi</span>
              <span class="rs">rs</span>
              <span>{{pkg.emiDetails.amount | format-amount}}</span>
            </p>
          </div>
          <div class="pricing-box">
            <p class="final-price">
              <span class="rs">rs</span>
              <span class="amount">{{pkg.startFromPrice | format-amount}}</span>
            </p>
            <p class="actual-price" v-if="pkg.strikeOffPrice">
              <span class="rs">rs</span>
              <span>{{pkg.strikeOffPrice | format-amount}}</span>
            </p>
          </div>
          <p class="twin">Per Person on twin sharing</p>
          <button type="button" class="btn btn-primary mt15" :class="pkg.holdAndPayValue ? 'mb25': 'mb10'" @click="goToDetailsPage(pkg.packageId, $event)">
            View Details
          </button>
          <p class="pay-hold" v-if="pkg.holdAndPayValue && userPayAndHoldEnabled">
            <span>Pay &amp; Hold</span>
            <span class="amount">
              <span class="rs">rs</span>
              <span>{{pkg.holdAndPayValue | format-amount}}</span>
            </span>
          </p>
          <!-- <button v-else type="button" class="btn btn-primary chatnow-btn mb5">
            <i class=" icon icon-chat-icon"></i> Chat Now</button> -->
          <p class="ecash" :class="{'place-bottom': !pkg.holdAndPayValue}">
            <span>Earn eCash</span>
            <span class="amount">
              <span class="rs">rs</span>
              <span>{{pkg.earnEcash | format-amount}}</span>
            </span>
          </p>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
/* global globalConfig */

import carousel from './carousel'
import constantData from '../common/constants'
export default {
  name: 'package',
  props: ['pkg', 'packageCompareToggled', 'userPayAndHoldEnabled'],
  components: {
    carousel
  },
  computed: {
    imagesList: function() {
      return [this.pkg.defaultSrpimg]
    }
  },
  watch: {
    packageCompareToggled: function() {
      this.$forceUpdate()
      this.toggleCompare++
    }
  },
  data() {
    return {
      inclusionClass: {
        Accommodation: 'beds',
        Flights: 'flight',
        Transfer: 'transfers',
        Sightseeing: 'sightseeing',
        Meals: 'meals',
        Volvo: 'bus'
      },
      detailsURL: '',
      toggleCompare: 0,
      packageDurationString: '',
      maxDestinationDispCount: constantData.maxDestinationDispCount
    }
  },
  methods: {
    compareToggled: function() {
      this.$emit('packageCompareToggled')
    },
    getDiscount: function(pkg) {
      return pkg.strikeOffPrice > 0 ? Math.floor((pkg.strikeOffPrice - pkg.startFromPrice) * 100 / pkg.strikeOffPrice) : 0
    },
    goToDetailsPage: function(packageId, e) {
      window.location.href = this.detailsURL
    },
    openSlideout: function() {
      this.$emit('openslideout', {
        slideOutName: 'newPackage',
        props: { pkg: this.pkg }
      })
    },
    openGallery: function(data) {
      this.$emit('openGallery', data)
    }
  },
  created: function() {
    this.detailsURL = 'details.htm?packageId=' + this.pkg.packageId
    if (globalConfig.parentPageIdVal) {
      this.detailsURL = this.detailsURL + '&parentPageId=' + globalConfig.parentPageIdVal
    }
    for (let i = 0; i < this.pkg.cityDurations.length && i < this.maxDestinationDispCount; i++) {
      this.packageDurationString = this.packageDurationString + ((i > 0) ? '   →   ' : '') + this.pkg.cityDurations[i].destinationName + ' (' + this.pkg.cityDurations[i].maxNights + 'N)'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#carousel-container {
  #image-slider {
    display: inline;
  }
}
.packages-list {
  transform: translateY(10px) 1s ease;
  transform: translateX(10px) 1s ease;
  transition: transform 1s;
}

.show-on-hover {
  opacity: 0;
  transition: opacity 0.5s ease-in;
}
.on-hover:hover .show-on-hover {
  opacity: 1;
}

.place-bottom {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/packageTuple.vue